import EventIcon from '@mui/icons-material/Event';
import UpdateIcon from '@mui/icons-material/Update';

import i18n from 'FRONTEND/utils/i18n';

export const getDateTimeStepSupport = () => {
  return {
    title: i18n._('How to specify a slot?'),
    text: i18n._('You can choose the slot you want in order to find a practitioner that is available at that time.'),
    paragraphList: [
      {
        title: i18n._('Pick a date and time'),
        text: i18n._('Click on the "desired slot" field and chose the date and time at which you want the appointment to be set.'),
        icon: EventIcon,
      },
      {
        title: i18n._('Set the appointment duration'),
        text: i18n._('You can set the duration you want by selecting it in the dropdown menu of the "appointment duration" field. It will be used to find slots in the practitioner’s schedule. Then click "Confirm".'),
        icon: UpdateIcon,
      },
    ],
  };
};
